/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type newShowroom = {|
  name: string,
  mainHeading: string,
  subHeading?: ?string,
  headerImage?: ?any,
  templateId: number,
  portalId: string,
  content?: ?$ReadOnlyArray<?InputContent>,
  uploads?: ?$ReadOnlyArray<uploadedFileInput>,
  tags?: ?$ReadOnlyArray<?string>,
  zoomedLevel?: ?number,
  draggableX?: ?number,
  draggableY?: ?number,
  link?: ?string,
  accountId: string,
  coverpagesIds?: ?$ReadOnlyArray<string>,
  backgroundImage?: ?any,
|};
export type InputContent = {|
  name: string,
  content?: ?$ReadOnlyArray<?InputNestedContent>,
|};
export type InputNestedContent = {|
  image: string,
  mainHeading: string,
  presentationId: string,
  subHeading: string,
  imageUrl: string,
  files?: ?$ReadOnlyArray<?FileInputs>,
  presentation?: ?PresentationInput,
|};
export type FileInputs = {|
  name: string,
  fileType: string,
  thumbnailUrl?: ?string,
  coverUrl?: ?string,
  fileUrl: string,
  audioUrl?: ?string,
  links?: ?$ReadOnlyArray<?LinkInputs>,
  tags?: ?$ReadOnlyArray<?string>,
  position: number,
|};
export type LinkInputs = {|
  name: string,
  url: string,
|};
export type PresentationInput = {|
  coverUrl?: ?string,
  folderId: string,
  menuId: string,
  portalId: string,
  name?: ?string,
|};
export type uploadedFileInput = {|
  presentationId: string,
  file: any,
|};
export type CreateShowroomMutationVariables = {|
  showroom?: ?newShowroom
|};
export type CreateShowroomMutationResponse = {|
  +createShowroom: ?{|
    +_id?: string,
    +id?: string,
    +name?: string,
    +portalId?: ?string,
    +mainHeading?: string,
    +subHeading?: string,
    +templateId?: number,
    +tags?: ?$ReadOnlyArray<string>,
    +link?: ?string,
    +accountId?: ?string,
    +creator?: string,
    +coverpagesIds?: ?$ReadOnlyArray<string>,
    +backgroundImage?: ?string,
    +createdAt?: any,
    +updatedAt?: ?any,
    +content?: ?$ReadOnlyArray<?{|
      +name: string,
      +content: ?$ReadOnlyArray<?{|
        +image: string,
        +mainHeading: string,
        +presentationId: string,
        +subHeading: string,
        +imageUrl: string,
        +presentation: ?{|
          +coverUrl: ?string
        |},
      |}>,
    |}>,
    +__typename: "Response",
    +message?: string,
    +status?: number,
    +success?: boolean,
    +token?: ?string,
    +hash?: ?string,
    +signedUrl?: ?string,
    +userId?: ?string,
  |}
|};
export type CreateShowroomMutation = {|
  variables: CreateShowroomMutationVariables,
  response: CreateShowroomMutationResponse,
|};
*/


/*
mutation CreateShowroomMutation(
  $showroom: newShowroom
) {
  createShowroom(showroom: $showroom) {
    __typename
    ... on Showroom {
      _id
      id
      name
      portalId
      mainHeading
      subHeading
      templateId
      tags
      link
      accountId
      creator
      coverpagesIds
      backgroundImage
      createdAt
      updatedAt
      content {
        name
        content {
          image
          mainHeading
          presentationId
          subHeading
          imageUrl
          presentation {
            coverUrl
          }
        }
      }
    }
    ... on Response {
      __typename
      message
      status
      success
      token
      hash
      signedUrl
      userId
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "showroom"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "showroom",
    "variableName": "showroom"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mainHeading",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subHeading",
  "storageKey": null
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "_id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "portalId",
      "storageKey": null
    },
    (v3/*: any*/),
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "templateId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tags",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "link",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "creator",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "coverpagesIds",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "backgroundImage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Content",
      "kind": "LinkedField",
      "name": "content",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "NestedContent",
          "kind": "LinkedField",
          "name": "content",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "image",
              "storageKey": null
            },
            (v3/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "presentationId",
              "storageKey": null
            },
            (v4/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "imageUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Presentation",
              "kind": "LinkedField",
              "name": "presentation",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "coverUrl",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Showroom",
  "abstractKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "token",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hash",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "signedUrl",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateShowroomMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "createShowroom",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/)
            ],
            "type": "Response",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateShowroomMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "createShowroom",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v5/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/)
            ],
            "type": "Response",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3fd372c486e307ce7e0188441657e21d",
    "id": null,
    "metadata": {},
    "name": "CreateShowroomMutation",
    "operationKind": "mutation",
    "text": "mutation CreateShowroomMutation(\n  $showroom: newShowroom\n) {\n  createShowroom(showroom: $showroom) {\n    __typename\n    ... on Showroom {\n      _id\n      id\n      name\n      portalId\n      mainHeading\n      subHeading\n      templateId\n      tags\n      link\n      accountId\n      creator\n      coverpagesIds\n      backgroundImage\n      createdAt\n      updatedAt\n      content {\n        name\n        content {\n          image\n          mainHeading\n          presentationId\n          subHeading\n          imageUrl\n          presentation {\n            coverUrl\n          }\n        }\n      }\n    }\n    ... on Response {\n      __typename\n      message\n      status\n      success\n      token\n      hash\n      signedUrl\n      userId\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c868e661d4388be52bc9d977d50d00f2';

module.exports = node;
